import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FieldProps } from 'formik';
import { InputHTMLAttributes } from 'react';
import { margin, MarginProps } from 'styled-system';
import colors from '../lib/colors';

interface Props
  extends FieldProps,
    Omit<
      InputHTMLAttributes<HTMLInputElement>,
      keyof FieldProps | keyof FieldProps['field']
    >,
    MarginProps {
  label: string;
  innerRef: React.RefObject<HTMLInputElement> | undefined;
  errorPosition?: 'label' | 'bottom';
}

const Input = ({
  field,
  form: { errors, touched },
  placeholder,
  label,
  errorPosition,
  innerRef,
  ...props
}: Props) => {
  const hasError = touched[field.name] === true && errors[field.name] != null;
  const { size } = { ...props };
  return (
    <>
      <input
        {...field}
        {...props}
        ref={innerRef}
        placeholder={
          hasError
            ? errorPosition === 'label' || !errorPosition
              ? String(errors[field.name])
              : ''
            : placeholder
        }
        aria-label={label}
        css={[
          css`
            display: block;
            margin: 8px 0;
            padding: 12px 16px;
            border: 1px solid ${colors.white};
            border-radius: 6px;
            background: ${colors.white};

            color: ${colors.black};
            font-size: 12px;
            letter-spacing: 0;

            &:focus {
              outline: none;
              box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.1);
            }

            &:disabled {
              background: ${colors.disabledInputBg};
              color: ${colors.disabledInputText};
            }
          `,
          hasError
            ? css`
                border-color: ${colors.danger};
                color: ${colors.danger};

                &::placeholder {
                  color: ${colors.danger};
                  opacity: 1;
                }
              `
            : undefined,
          margin(props),
        ]}
      />
      {hasError && errorPosition === 'bottom' && (
        <ErrorText size={size}>{errors[field.name]}</ErrorText>
      )}
    </>
  );
};

export default Input;

const ErrorText = styled.p<{ size?: number }>`
  font-size: 0.8em;
  color: ${colors.danger};
  width: ${({ size }) => size && `${size * 0.5}em`};
`;
